import { render, staticRenderFns } from "./ServiceCodeViewDetail.vue?vue&type=template&id=cf67da50"
import script from "./ServiceCodeViewDetail.vue?vue&type=script&lang=js"
export * from "./ServiceCodeViewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports